import { render, staticRenderFns } from "./goods-allocation-apply-detail-modal.component.vue?vue&type=template&id=0bd6f05e"
import script from "./goods-allocation-apply-detail-modal.component.vue?vue&type=script&lang=js"
export * from "./goods-allocation-apply-detail-modal.component.vue?vue&type=script&lang=js"
import style0 from "./goods-allocation-apply-detail-modal.component.vue?vue&type=style&index=0&id=0bd6f05e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports